import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { Navbar, Container } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'
import { useLanguage } from '../../Context/LanguageContext'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'

// Import Assets
import logoLight from '../../Assets/img/imigo-logo.png'
import logoDark from '../../Assets/img/imigo-logo.png'

const HeaderImigo = (props) => {
  const { topSpace, headerHeight } = props;
  const { setHeaderHeight } = useContext(GlobalContext);
  const { t, getLocalizedPath } = useLanguage();
  const location = useLocation();
  const headerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setHeaderHeight(headerRef.current.offsetHeight);
    }, 500);

    window.addEventListener('resize', () => {
      setTimeout(() => {
        setHeaderHeight(headerRef.current.offsetHeight);
      }, 500);
    });
  }, [setHeaderHeight]);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 100) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <header
      className={`header-imigo ${topSpace ? "top-space" : ""} ${
        scrolled ? "sticky-header" : ""
      }`}
      ref={headerRef}
    >
      <Navbar expand="lg" className="py-0 px-0 h-[90px]">
        <Container fluid className="px-[30px] h-full">
          <Link
            aria-label="header logo"
            className="flex items-center"
            to={getLocalizedPath('/')}
          >
            <img
              className="h-[60px] w-auto"
              src={scrolled ? logoDark : logoLight}
              alt="Imigo Logo"
            />
          </Link>
          <div className="flex items-center">
            <Navbar.Toggle
              className="navbar-toggler rounded-0 p-0"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse
            id="navbarNav"
            className={`${isOpen ? "show" : ""}`}
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/')}>
                  {t('menu.home')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/articles')}>
                  {t('menu.articles')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/businesses')}>
                  {t('menu.businesses')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/events')}>
                  {t('menu.events')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/marketplace')}>
                  {t('menu.marketplace')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/about')}>
                  {t('menu.about')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={getLocalizedPath('/contact')}>
                  {t('menu.contact')}
                </Link>
              </li>
            </ul>
            <div className="download-app-buttons ml-auto flex items-center gap-2">
              <LanguageSwitcher />
              <a href="https://apps.apple.com/us/app/imigo-connect/id6744267446" className="btn btn-sm btn-primary">{t('common.iosApp')}</a>
              <a href="https://play.google.com/store/apps/details?id=app.imigo" className="btn btn-sm btn-primary">{t('common.androidApp')}</a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default HeaderImigo 